import {useEffect, useState} from 'react';

export default ({timeout_key, cooldown_timestamp, hoursOnly, children}) => {
    const [timestamp, setTimestamp] = useState(cooldown_timestamp);
    const [time, setTime] = useState(timestamp - Date.now());

    useEffect(() => {
        setTimestamp(cooldown_timestamp);
        setTime(cooldown_timestamp - Date.now());
    }, [cooldown_timestamp])

    useEffect(() => {
        if(time < 0)
            return;

        if(typeof window.cooldownBlocksTimeout === "undefined")
            window.cooldownBlocksTimeout = {};

        window.cooldownBlocksTimeout[timeout_key] = setTimeout(() => {
            setTime(timestamp - Date.now());
        }, 500);
        return () => window.clearTimeout(window.cooldownBlocksTimeout[timeout_key]);
    }, [time]);

    const format = t => {
        const days = !hoursOnly ? Math.floor(t / (24 * 60 * 60 * 1e3)) : 0;
        t -= days * (24 * 60 * 60 * 1e3);
        const hours = Math.floor(t / (60 * 60 * 1e3));
        t -= hours * (60 * 60 * 1e3);
        const minutes = Math.floor(t / (60e3));
        t -= minutes * 60e3;
        const seconds = Math.floor(t / 1e3);

        return {
            days,
            hours,
            minutes,
            seconds
        }
    }

    const {days, hours, minutes, seconds} = format(time);

    if(time > 0) 
        return `${days > 0 ? `${days}d` : ''} ${(hours > 0 || days > 0) ? `${hours}h` : ''} ${(minutes > 0 || hours > 0) ? `${minutes}m` : ''} ${(seconds > 0 || minutes > 0) ? `${seconds}s` : ''}`.trim();

    return children;
}